module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"page-title":"Latest Press Releases","msg0":"Browse press releases","msg1":"Press Releases","msg2":"Published on"},"ar":{"page-title":"آخر الأخبار والبيانات الصحفية","msg0":"تصفح جميع البيانات الصحفية","msg1":"المركز الإعلامي","msg2":"نشرت في"}}')
  delete Component.options._Ctor
}
